import { AnchorButton } from '@givebutter/primitives/anchor-button';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GB_DASHBOARD_URL } from 'lib/constants';

const GoToGivebutterButton = ({ accountId }: { accountId: string | undefined }) => {
  const href = accountId
    ? `${GB_DASHBOARD_URL}/accounts/${accountId}/settings/developers/widgets`
    : GB_DASHBOARD_URL;

  return (
    <div className="flex flex-col items-center gap-2">
      <p className="text-center text-xs text-gray-600">
        Head to Givebutter.com to manage campaigns and related payment preferences.
      </p>
      <AnchorButton
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        variant="solid"
        className="rounded-full bg-blue-50 p-3.5 font-normal text-blue-600 [&:hover>svg]:text-white [&>svg]:text-blue-600"
        size="xs"
      >
        Givebutter Settings
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="" />
      </AnchorButton>
    </div>
  );
};

export { GoToGivebutterButton };
